import { api } from '../core';

export interface BreachPage {
  pageId: string;
  pageNumber: number;
}

export interface GdprSummaryResponse {
  blankCount: number;
  breachCount: number;
  breachPages: BreachPage[];
  pageCount: number;
  flagCount: number;
  aiChecked: boolean;
}

export interface GetGdprSummaryProps {
  abortController?: AbortController;
  documentId: string;
}

const getGdprSummaryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getGdprSummary: builder.query<GdprSummaryResponse, GetGdprSummaryProps>({
      query: ({ abortController = new AbortController(), documentId }: GetGdprSummaryProps) => ({
        url: `gdpr/summary?document_id=${documentId}`,
        method: 'GET',
        signal: abortController.signal
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const { useLazyGetGdprSummaryQuery, useGetGdprSummaryQuery } = getGdprSummaryApi;
